// SecPose slice — platform-specific data the IO boundary needs that the
// reference (file-based) loaders didn't: the raw per-side predictions kept for
// re-serialization at submit time, and the per-side frame→image-URL maps that
// ImageCanvas renders from (the worker proxies images at /secpose-image/...).

import type { StateCreator } from 'zustand';
import type { NewPredictionsFile } from '../types';
import type { AppState } from './index';
import type { Side } from './predictions';

/** frame index → proxied image URL, per side. */
export type SideImageUrls = Partial<Record<Side, Record<number, string>>>;
export type SideRawPredictions = Partial<Record<Side, NewPredictionsFile>>;
export type SideLegacySeedFrames = Partial<Record<Side, number[]>>;
export type SecPosePoseSeedSource = 'blank' | 'legacy_v1';

export interface SecPoseSlice {
  rawPredictions: SideRawPredictions;
  imageUrls: SideImageUrls;
  poseSeedSource: SecPosePoseSeedSource;
  legacySeedFrames: SideLegacySeedFrames;
  setSecPoseData: (
    raw: SideRawPredictions,
    urls: SideImageUrls,
    poseSeedSource?: SecPosePoseSeedSource,
    legacySeedFrames?: SideLegacySeedFrames
  ) => void;
  resetSecPose: () => void;
}

export const createSecPoseSlice: StateCreator<
  AppState,
  [['zustand/immer', never]],
  [],
  SecPoseSlice
> = (set) => ({
  rawPredictions: {},
  imageUrls: {},
  poseSeedSource: 'blank',
  legacySeedFrames: {},
  setSecPoseData: (raw, urls, poseSeedSource = 'blank', legacySeedFrames = {}) =>
    set((s) => {
      s.rawPredictions = raw;
      s.imageUrls = urls;
      s.poseSeedSource = poseSeedSource;
      s.legacySeedFrames = legacySeedFrames;
    }),
  resetSecPose: () =>
    set((s) => {
      s.rawPredictions = {};
      s.imageUrls = {};
      s.poseSeedSource = 'blank';
      s.legacySeedFrames = {};
    }),
});
